export const snackbarStop = async ({ commit }) => {
  commit('snackbarStop');
};

// eslint-disable-next-line no-unused-vars
export const warning = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'warning' });
};

// eslint-disable-next-line no-unused-vars
export const danger = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'error' });
};

export const error = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'error' });
};

// eslint-disable-next-line no-unused-vars
export const notify = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'orange darken-1' });
};

// eslint-disable-next-line no-unused-vars
export const info = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'info' });
};

// eslint-disable-next-line no-unused-vars
export const success = async ({ commit }, message) => {
  console.log(message);
  commit('snackbarStart', { message, color: 'success' });
};
